import React, { useState, useEffect } from 'react';
import { TextField, Button, Grid, MenuItem, Select, InputLabel, FormControl, Autocomplete } from '@mui/material';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
function GestionUsuario({ onNewUsuario, editUsuario }) {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [codigoUsuario, setCodigoUsuario] = useState('');
    const [clave, setClave] = useState('');
    const [nombreCompleto, setNombreCompleto] = useState('');
    const [idEmpresa, setIdEmpresa] = useState('');
    const [idEmpleado, setIdEmpleado] = useState('');
    const [idEmpleadoTicket, setIdEmpleadoTicket] = useState('');
    const [nombreEmpleado, setNombreEmpleado] = useState('');
    const [empresas, setEmpresas] = useState([]);
    const [empleados, setEmpleados] = useState([]);
    const [empleadosTicket, setEmpleadosTicket] = useState([]);
    const [modificacion, setModificacion] = useState(1); // Nuevo estado para manejar la modificación
    const [isEditing, setIsEditing] = useState(false);
    const { user } = useUser();
    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
        fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
        return fechaISO;
    }

    const fechaFormateada = obtenerFechaISOsinZ();


    useEffect(() => {
        // Fetch las empresas desde la API
        const fetchEmpresas = async () => {
            try {
                const response = await fetch(`${server}/MgEmpresas`); // Cambia la URL según tu API
                const data = await response.json();
                setEmpresas(data.$values);
                // console.log(data.$values);
            } catch (error) {
                console.error('Error al cargar las empresas:', error);
            }
        };

        const fetchEmpleados = async () => {
            try {
                const response = await fetch(`${server}/PlEmpleadoes`); 
                const data = await response.json();
                setEmpleados(data.$values);
                // console.log(data.$values);
            } catch (error) {
                console.error('Error al cargar las empresas:', error);
            }
        };

        const fetchEmpleadosTicket = async () => {
            try {
                const response = await fetch(`${server}/tickets/tbl_login`); 
                const data = await response.json();
                setEmpleadosTicket(data.$values);
                 console.log(data.$values);
            } catch (error) {
                console.error('Error al cargar las empresas:', error);
            }
        };

        fetchEmpresas();
        fetchEmpleados();
        fetchEmpleadosTicket();
    }, []);

    useEffect(() => {
        if (editUsuario) {
            setCodigoUsuario(editUsuario.codigoUsuario);
            setNombreCompleto(editUsuario.nombreCompleto);
            setIdEmpleado(editUsuario.idEmpleado);
            setNombreEmpleado(editUsuario.nombreCompleto);
            setClave(editUsuario.clave);
            setIdEmpresa(editUsuario.idEmpresa);
            setIdEmpleadoTicket(editUsuario.codUsuarioTickets);
            setModificacion(2);
            setIsEditing(true);
console.log(editUsuario);

        }
    }, [editUsuario]);

    const handleCancelarEdicion = () => {
        setCodigoUsuario('');
        setNombreCompleto('');
        setNombreEmpleado('');
        setClave('');
        setIdEmpleado('');
        setIdEmpresa('');
        setIdEmpleadoTicket('');
        setModificacion(1);
        setIsEditing(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const nuevoUsuario = {
            codigoUsuario: codigoUsuario,
            clave,
            nombreCompleto: nombreEmpleado,
            idEmpleado: idEmpleado,
            idEmpresa: idEmpresa,
            ingresadoPor: !isEditing ? (user ? user.codigoUsuario : 'ADMIN               ' ) : undefined,
            ModificadoPor: isEditing ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
            codUsuarioTickets: idEmpleadoTicket
            // fechaIngreso: new Date().toISOString(),
            // modificacion
        };

        // console.log(editUsuario.codigoUsuario);
         console.log(nuevoUsuario);
        try {
            const response = await fetch(`${server}/MgUsuarios${isEditing ? '/' + editUsuario.codigoUsuario : ''}`, {
                method: isEditing ? 'PUT' : 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(nuevoUsuario),
            });
console.log(response);
            if (response.ok) {
                alert('Usuario creado con éxito');
                handleCancelarEdicion();
                onNewUsuario();
                // Opcional: Lógica adicional como limpiar los campos o actualizar una lista
            } else {
                alert('Error al administrar el usuario');
            }
        } catch (error) {
            console.error('Error al crear el usuario:', error);
            alert('Error al crear el usuario');
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>

                        <Autocomplete
                            fullWidth
                            options={empleados} // La lista de opciones
                            getOptionLabel={(option) => option.nombreCompleto} // Lo que se mostrará en la lista
                            value={empleados.find((empleado) => empleado.idEmpleado === idEmpleado) || null} // Valor seleccionado
                            onChange={(event, newValue) => {
                                setIdEmpleado(newValue ? newValue.idEmpleado : ''); // Guarda el ID del empleado seleccionado
                                setNombreEmpleado(newValue ? newValue.nombreCompleto : ''); // Guarda el nombre del empleado seleccionado
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Empleado" // Etiqueta del campo
                                    variant="outlined" // Estilo del campo, puedes usar "filled" o "standard" también
                                    required // Hace que el campo sea obligatorio
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Código de Usuario"
                            value={codigoUsuario}
                            onChange={(e) => setCodigoUsuario(e.target.value.replace(/\s+/g, ''))} // Reemplazar espacios por nada
                            required
                            disabled={isEditing} // Deshabilitar cuando estás editando
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Clave"
                            type="password"
                            value={clave}
                            onChange={(e) => setClave(e.target.value.replace(/\s+/g, ''))}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Nombre Completo"
                            value={nombreEmpleado}
                            onChange={(e) => setNombreCompleto(e.target.value)}
                            required
                            readonly
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth required>
                            <InputLabel>Empresa</InputLabel>
                            <Select
                                value={idEmpresa}
                                onChange={(e) => setIdEmpresa(e.target.value)}
                            >
                                {empresas.map((empresa) => (
                                    <MenuItem key={empresa.idEmpresa} value={empresa.idEmpresa}>
                                        {empresa.nombreCompleto}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                    <Autocomplete
                            fullWidth
                            options={empleadosTicket}
                            getOptionLabel={(option) => option.login + '-' + option.nombre_personal} 
                            value={empleadosTicket.find((empleado) => empleado.id_personal === idEmpleadoTicket) || null}
                            onChange={(event, newValue) => {
                                setIdEmpleadoTicket(newValue ? newValue.id_personal : '');
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Usuario Ticket"
                                    variant="outlined"
                                    required
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button type="submit" variant="contained" color="primary" disabled={!tienePermiso('Crear Usuario')}>
                            {isEditing ? 'Actualizar' : 'Crear'} Usuario
                        </Button>
                        {isEditing && (
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={handleCancelarEdicion}
                                style={{ marginLeft: '10px' }}
                            >
                                Cancelar Edición
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </form>
        </>
    );
}

export default GestionUsuario;
